// src/Home.js
import React, { useEffect, useState } from 'react';
import { useUser } from './contexts/UserContext';
import { hasActiveSubscription } from './services/stripeService';
import './App.css';

const Home = () => {
  const { user, userData } = useUser();
  const [subscriptionActive, setSubscriptionActive] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkSubscriptionStatus = async () => {
      if (user && userData) {
        try {
          const hasActive = await hasActiveSubscription();
          setSubscriptionActive(hasActive);
        } catch (error) {
          console.error('Error checking subscription status:', error);
          setSubscriptionActive(false);
        }
      }
      setLoading(false);
    };

    checkSubscriptionStatus();
  }, [user, userData]);

  if (loading) {
    return (
      <div className="Home">
        <p>Loading...</p>
      </div>
    );
  }

  return (
    <div className="Home">
      <p>
        {subscriptionActive ? 'Welcome to Subscribed' : 'Welcome'}
      </p>
    </div>
  );
};

export default Home;
